import actions from '../../../../redux/actions/ui/dataImport/strategies/productCartBridgeStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function ProductCartBridgeStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

ProductCartBridgeStrategy.title = actions.title
const option = {
  value: 'update_pcb',
  display: 'Update Product/Sales Channel Bridge',
  category: 'products',
  Component: ProductCartBridgeStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductCartBridgeStrategy.option = option
